export default __webpack_public_path__ + "static/media/Smiley.61f10e03.svg";